module.exports = __webpack_public_path__ + "static/img/200199.2cf08517.png";